import '@workspace/ui/globals.css';

import * as Sentry from '@sentry/react';
import { createRouter, RouterProvider } from '@tanstack/react-router';
import { Toaster } from '@workspace/ui/components/sonner';
import { Spinner } from '@workspace/ui/components/spinner';
import { ThemeProvider } from '@workspace/ui/components/theme-provider';
import { Suspense } from 'react';

import LoginLayout from './components/login-layout';
import { SENTRY_DSN_AUTH } from './config/environment';

// Import the generated route tree
import { routeTree } from './routeTree.gen';

Sentry.init({
  dsn: SENTRY_DSN_AUTH,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
});

const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
});

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const App = () => {
  return (
    <ThemeProvider defaultTheme="dark" storageKey="ui-theme">
      <Suspense fallback={<Spinner />}>
        <LoginLayout>
          <Toaster richColors closeButton />
          <RouterProvider router={router} />
        </LoginLayout>
      </Suspense>
    </ThemeProvider>
  );
};

export default App;
